'use strict';
import angular from 'angular';
import './scripts/reporting.ctrls';
import './scripts/reporting.directives';
import './scripts/reporting.services';

import orderReportHtmlUrl from './views/orderReport.html';
import lineItemReportsHtmlUrl from './views/lineItemReports.html';
import tasksReportsHtmlUrl from './views/tasksReports.html';
import masterReportHtmlUrl from './views/masterReport.html';
import slotBookingReportHtmlUrl from './views/slotBookingReport.html';
import orderHistoryReportHtmlUrl from './views/orderHistoryReport.html';
import lineItemHistoryReportHtmlUrl from './views/lineItemHistoryReport.html';

angular.module('reporting', [
    'reporting.ctrls',
    'reporting.services',
    'reporting.directives'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('reportOrders', {
                parent: 'layout',
                url: '/reporting/orders',
                templateUrl: orderReportHtmlUrl,
                controller: 'OrderReportController',
            })
            .state('lineItemReports', {
                parent: 'layout',
                url: '/reporting/lineItems',
                templateUrl: lineItemReportsHtmlUrl,
                controller: 'LineItemReportsController',
            })
            .state('tasksReports', {
                parent: 'layout',
                url: '/reporting/tasks',
                templateUrl: tasksReportsHtmlUrl,
                controller: 'TasksReportsController',
            })
            .state('masterReport', {
                parent: 'layout',
                url: '/reporting/master',
                templateUrl: masterReportHtmlUrl,
                controller: 'MasterReportController',
            })
            .state('slotBookingReport', {
                parent: 'layout',
                url: '/reporting/slotBookings',
                templateUrl: slotBookingReportHtmlUrl,
                controller: 'SlotBookingReportController',
            })
            .state('orderHistoryReport', {
                parent: 'layout',
                url: '/reporting/orderHistory',
                templateUrl: orderHistoryReportHtmlUrl,
                controller: 'OrderHistoryReportController',
            })
            .state('lineItemHistoryReport', {
                parent: 'layout',
                url: '/reporting/lineItemHistory',
                templateUrl: lineItemHistoryReportHtmlUrl,
                controller: 'LineItemHistoryReportController',
            })
    }]);